






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { Property } from '@/modules/Property/interfaces/property'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'

@Component({
  components: {
    AppSystemInfoCard
  }
})
export default class PropertyDetailAdditional extends Vue {
  @Prop({ type: Object as () => Property }) readonly property!: Property
}
